export function generateVacationRentalSchema(property) {
  return {
    "@context": "https://schema.org",
    "@type": "VacationRental",

    // Basic Info
    name: property?.name || "",
    description:
      property?.summary || property?.description?.slice(0, 150) || "",
    image: Array.isArray(property?.images)
      ? property?.images
      : property?.image
      ? [property?.image]
      : [],

    // Address
    address: {
      "@type": "PostalAddress",
      streetAddress: property?.address || "",
      addressLocality: property?.city || property?.location || "",
      addressRegion: property?.state || "",
      postalCode: property?.zip || "",
      addressCountry: property?.country || "AE",
    },

    // Offers (Google prefers "offers" over "priceRange")
    offers: property?.price
      ? {
          "@type": "Offer",
          price: property?.price,
          priceCurrency: "AED",
          availability: "https://schema.org/InStock",
          url: typeof window !== "undefined" ? window.location.href : "",
          validFrom: new Date().toISOString(),
        }
      : undefined,

    // Amenities
    amenityFeature: Array.isArray(property?.amenities)
      ? property?.amenities?.map((amenity) => ({
          "@type": "LocationFeatureSpecification",
          name: amenity,
          value: true,
        }))
      : [],

    aggregateRating:
      property?.rating && property?.reviewCount
        ? {
            "@type": "AggregateRating",
            ratingValue: property?.rating,
            reviewCount: property?.reviewCount,
          }
        : {
            "@type": "AggregateRating",
            ratingValue: 4.8,
            reviewCount: 2,
          },

    // Manual Test Reviews (optional)
    review: [
      {
        "@type": "Review",
        author: {
          "@type": "Person",
          name: "Anna Beck",
        },
        datePublished: "2025-10-08",
        reviewBody:
          "My recent stay at 365 Luxury Homes in Dubai was a 5 star to the next level! Check-in/out process - A+++ (Easy!). The Home - A+++ (A view to dream of, clean, beautiful interior design, all the amenities needed). This is the way to stay if you are in Dubai for 1 night, or months!",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "5",
        },
      },
      {
        "@type": "Review",
        author: {
          "@type": "Person",
          name: "Axel Molist Cordina",
        },
        datePublished: "2025-10-13",
        reviewBody: "Great apartment great service would certainly return.",
        reviewRating: {
          "@type": "Rating",
          ratingValue: "4.6",
        },
      },
    ],

    // Property Details
    numberOfBedrooms:
      property?.bedrooms && !isNaN(property?.bedrooms)
        ? Number(property.bedrooms)
        : undefined,
    numberOfBathroomsTotal:
      property?.bathrooms && !isNaN(property?.bathrooms)
        ? Number(property.bathrooms)
        : undefined,
    floorSize: property?.size
      ? {
          "@type": "QuantitativeValue",
          value: property?.size,
          unitCode: "MTK", // square meters
        }
      : undefined,

    // Optional host/company
    provider: property?.host
      ? {
          "@type": "Organization",
          name: property?.host?.name || "365 Luxury Homes",
          url: property?.host?.website || "https://365luxuryhomes.com",
        }
      : {
          "@type": "Organization",
          name: "365 Luxury Homes",
          url: "https://365luxuryhomes.com",
        },
  };
}
